import type { ReactNode } from "react";

interface BadgeProps {
  children: ReactNode;
  tone?: "primary" | "accent" | "secondary" | "neutral";
  className?: string;
}

const toneMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-800",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-100 text-secondary-800",
  neutral: "bg-background-200 text-foreground-700",
};

export default function Badge({ children, tone = "secondary", className = "" }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium leading-5 ${toneMap[tone]} ${className}`}
    >
      {children}
    </span>
  );
}